<template>
  <div id="app">
    <HeaderBar></HeaderBar>
    <Container>
      <CompatibilityChecker></CompatibilityChecker>
    </Container>
  </div>
</template>

<script>
  import CompatibilityChecker from './components/CompatibilityChecker.vue'
  import Container from './components/Container.vue'
  import HeaderBar from './components/HeaderBar.vue'

  export default {
    name: 'App',
    components: {
      CompatibilityChecker,
      Container,
      HeaderBar,
    }
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    analyticsGranted: true,
    behavioralGranted: true,
    event: 'tracking-consent'
  });
</script>

<style lang="scss">
  @import '../assets/fonts';
  @import url('../assets/verizon-nhg.css');

  body {
    margin: 0;
    padding: 0;
    font-family: $text-font;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  h1, h2, h3, h4, h5 {
    font-family: $display-font;
  }
  #app {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    min-height: 100vh;
  }
</style>
